const state = {
        cu: {
                id: '',
                first_name: '',
                last_name: '',
                email: '',
                role: '',
                status: '',
                pharmacy_token: '',
        },
        greeners: {
                id: '',
                first_name: '',
                last_name: '',
                email: '',
                role: '',
                status: '',
        },
        searchTerm: '', // Add searchTerm property
};

const mutations = {
        cu: (state, val) => {
                state.cu = val;
        },
        greeners: (state, val) => {
                state.greeners = val;
        },
        updateSearchTerm(state, newSearchTerm) { // Define mutation for updating searchTerm
                state.searchTerm = newSearchTerm;
        },
};

const actions = {
        cu: ({ commit }, val) => {
                commit("cu", val);
        },
        greeners: ({ commit }, val) => {
                commit("greeners", val);
        },
};

const getters = {
        cu: (state) => {
                return state.cu;
        },
        greeners: (state) => {
                return state.greeners;
        },
        state: (state) => {
                return {
                        cu: state.cu,
                        searchTerm: state.searchTerm, // Include searchTerm in the returned state
                };
        },
};

export default {
        namespaced: true,
        state,
        mutations,
        actions,
        getters,
};
